import {Component, ViewEncapsulation} from '@angular/core';
import { CdkScrollbarDirective } from '../../../../@cdk/directives/cdk-scrollbar/cdk-scrollbar.directive';
import { AjudaComponent } from '../../../../ajuda/ajuda.component';

@Component({
    selector: 'ajuda-panel',
    templateUrl: './ajuda-panel.component.html',
    styleUrls: ['./ajuda-panel.component.scss'],
    encapsulation: ViewEncapsulation.None,
        imports: [CdkScrollbarDirective, AjudaComponent]
})
export class AjudaPanelComponent {
}
